export type MultiValueItem = {
  id: string;
  label: string;
  href?: string;
  onClick?: () => void;
};

export type MultiValueSeparator = '|' | ',';

function pushLabel(parts: string[], raw: unknown, separator: MultiValueSeparator) {
  if (raw == null || typeof raw === 'boolean') return;
  if (typeof raw === 'object') return;

  String(raw)
    .split(separator)
    .forEach(piece => {
      const label = piece.trim();
      if (!label || label === '-') return;
      parts.push(label);
    });
}

export function toMultiValueLabels(value: unknown, separator: MultiValueSeparator = '|'): string[] {
  const parts: string[] = [];
  if (Array.isArray(value)) value.forEach(item => pushLabel(parts, item, separator));
  else pushLabel(parts, value, separator);

  const seen = new Set<string>();
  return parts.filter(label => {
    if (seen.has(label)) return false;
    seen.add(label);
    return true;
  });
}

export function toMultiValueItems(value: unknown, separator: MultiValueSeparator = '|'): MultiValueItem[] {
  return toMultiValueLabels(value, separator).map(label => ({ id: label, label }));
}
